import { NivelI } from "interfaces/Nivel";

export interface infoFetchGetNivelI {
  id: number | string;
  nombre: string;
}

class Nivel implements NivelI {
  id: number | string;
  nombre: string;

  constructor(dto: infoFetchGetNivelI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
  }
}

export const makeNivel = (infoFetch: infoFetchGetNivelI) => {
  return new Nivel(infoFetch);
};
